import React from 'react'

import moment from 'moment'

import { Typography, Row, Col, Divider } from 'antd'

import { FlexBoxY } from 'common/components/boxes'
import Address from 'common/components/full_address'

import { Delivery } from 'vendor/server/deliveries'

import { ItemTitle } from './item_title'

interface RequestProps {
  delivery: Delivery
}

export const Request = ({ delivery }: RequestProps) => {
  const { requested_delivered_at } = delivery

  return (
    <>
      <Typography.Paragraph strong>Request</Typography.Paragraph>

      <Row gutter={[20, 20]}>
        <Col xs={24} sm={12}>
          <FlexBoxY justifyContent="flex-start" alignItems="flex-start">
            <ItemTitle text="Requested Date" />
            {requested_delivered_at ? moment(requested_delivered_at).format('MM/DD/YYYY') : 'Unspecified'}

            <Divider />

            <ItemTitle text="Instructions" />
            {delivery.instructions}
          </FlexBoxY>
        </Col>

        <Col xs={24} sm={12}>
          <FlexBoxY justifyContent="flex-start" alignItems="flex-start">
            <ItemTitle text="Address" />
            <Address address={delivery.address} showDetails />
          </FlexBoxY>
        </Col>
      </Row>
    </>
  )
}
